var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beverage-types",on:{"click":_vm.typeClick}},[_c('div',[_c('img',{attrs:{"src":require('../../assets/' + _vm.bt.imgName + '.jpg'),"alt":"bt.imgName"}}),_c('h4',{staticClass:"name"},[_vm._v(_vm._s(_vm.bt.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }